import React from 'react';
import classNames from 'classnames';
import Spinner from './spinner';

export default function QrCodeUploading({
  fileCount,
  handleUploadingQrCodeButton,
  compact = false,
}) {
  return (
    <>
      <h3
        className={classNames('title service-title font-weight-bold', {
          'mt-5': !compact,
          'tw-text-base tw-mt-2': compact,
        })}>
        {fileCount} photos are being uploaded from your phone
      </h3>
      <small className="d-block image-loader__qr-code-instructions">
        Please wait while the photos are being transferred
      </small>
      {!compact && (
        <small className="d-block image-loader__qr-code-instructions">
          This window will close automatically once the upload is complete
        </small>
      )}
      <small
        className={classNames('d-block image-loader__qr-code-instructions', {
          'mb-4': !compact,
          'tw-mb-2': compact,
        })}>
        <button
          className="btn btn-link btn-sm"
          aria-label="Display QR code"
          role="button"
          onClick={handleUploadingQrCodeButton}>
          Display Qr code
        </button>
      </small>
      <Spinner />
    </>
  );
}
